<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" sm="10">
                <v-row>
                    <v-col cols="12" class="mb-3">
                        <h3 v-text="$t('lieferant.details.title')" />
                    </v-col>
                </v-row>

                <v-row class="pb-5">
                    <!-- Lieferant Label -->
                    <v-col cols="12" sm="2" class="d-flex align-items-center text-nowrap"> {{ $t('lieferant.details.lieferantAnschrift') }}: </v-col>

                    <!-- Lieferant Info -->
                    <v-col cols="12" sm="4">
                        <div class="mb-1">{{ lieferantDaten?.firma || '-' }}</div>
                        <div class="mb-1">
                            {{ (lieferantDaten?.adresszeile1 || '') + (lieferantDaten?.adresszeile2 ? ' ' + lieferantDaten?.adresszeile2 : '') }}
                        </div>
                        <div>{{ (lieferantDaten?.plz || '') + ' ' + (lieferantDaten?.ort || '') }}</div>
                    </v-col>

                    <!-- Additional Details -->
                    <v-col cols="12" sm="6">
                        <v-row>
                            <v-col cols="4" class="py-0 text-nowrap"> {{ $t('lieferant.details.mwstNummer') }}: </v-col>
                            <v-col cols="8" class="py-0">
                                {{ lieferantDaten?.mwstNummer }}
                            </v-col>
                            <v-col cols="4" class="py-0 text-nowrap"> {{ $t('lieferant.details.land') }}: </v-col>
                            <v-col cols="8" class="py-0">
                                {{ lieferantDaten?.land }}
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row>
                    <!-- Edit Dialog -->
                    <v-col cols="auto">
                        <EditLieferantDetails :lieferant-data="lieferantDaten" @success="$emit('success')" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { LieferantStammdatenApiDto } from '@/api-schema';

import EditLieferantDetailsDialog from './EditLieferantDetailsDialog.vue';
@Component({
    components: {
        EditLieferantDetails: EditLieferantDetailsDialog
    }
})
export default class LieferantDetails extends Vue {
    @Prop({ required: true, type: Object })
    private lieferantDaten!: LieferantStammdatenApiDto;
}
</script>

<style scoped>
.no-wrap {
    white-space: nowrap;
}
</style>
